module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.$route.path == '/productInformation/otherProduct') ? _c('div', [_c('el-form', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "min-width": "900px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单品编号:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.productId),
      callback: function($$v) {
        _vm.$set(_vm.query, "productId", $$v)
      },
      expression: "query.productId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称:",
      "label-width": "50px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.productName),
      callback: function($$v) {
        _vm.$set(_vm.query, "productName", $$v)
      },
      expression: "query.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目:",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择项目"
    },
    model: {
      value: (_vm.query.ProSubjection),
      callback: function($$v) {
        _vm.$set(_vm.query, "ProSubjection", $$v)
      },
      expression: "query.ProSubjection"
    }
  }, _vm._l((_vm.ProSubjectionNames), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.id,
        "label": option.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型:",
      "label-width": "60px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.query.ProTypeId),
      callback: function($$v) {
        _vm.$set(_vm.query, "ProTypeId", $$v)
      },
      expression: "query.ProTypeId"
    }
  }, _vm._l((_vm.ProTypeNames), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.ParmName
      }
    })
  }))], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "arrow-down"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增商品")])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading2),
      expression: "loading2"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.List,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "单品ID",
      "prop": "ProductId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProCode",
      "label": "单品编号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "销量",
      "prop": "OrderNum",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProSubjectionName",
      "label": "项目",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProTypeName",
      "label": "类型",
      "width": "172"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "StockType",
      "label": "发货仓库类型",
      "width": "172"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AddUserName",
      "label": "新建人",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AddTime",
      "label": "新建时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "350px",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "view",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.ProVisit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "disabled": (scope.row.btnVue & 4) <= 0,
            "icon": "edit",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "disabled": (scope.row.btnVue & 8) <= 0,
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.delProduct(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "disabled": (scope.row.btnVue & 32) <= 0,
            "icon": "circle-cross",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              _vm.forbidden(scope.$index, scope.row)
            }
          }
        }, [_vm._v("禁用")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _c('div', [_c('transition', [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a52249e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/productInformation/otherProduct.vue
// module id = 1533
// module chunks = 1